<script setup>
import { ref, computed } from 'vue'
import Home from './routes/Home.vue'
import Order from './routes/Order.vue'
import Track from './routes/Track.vue'
import Start from './routes/Start.vue'
import Photos from './routes/Photos.vue'
import Compensation from './routes/Compensation.vue'
import Review from './routes/Review.vue'
import ShippingAddress from './routes/ShippingAddress.vue'
import Claims from './routes/Claims.vue'
import Claim from './routes/Claim.vue'
import Lost from './routes/Lost.vue'
import Other from './routes/Other.vue'
import Ineligible from './routes/Ineligible.vue'
import Credit from './routes/Credit.vue'
import EditShippingAddress from './routes/EditShippingAddress.vue'
import Success from './routes/Success.vue'
import Details from './routes/Details.vue'
import Damage from './routes/Damage.vue'

//region Router
const routes = {
  '/': Home,
  '/order': Order,
  '/order/track': Track,
  '/claim/start': Start,
  '/claim/ineligible': Ineligible,
  '/claim/photos': Photos,
  '/claim/damage': Damage,
  '/claim/lost': Lost,
  '/claim/other': Other,
  '/claim/compensation': Compensation,
  '/claim/compensation/credit': Credit,
  '/claim/compensation/replacement': Credit,
  '/claim/shipping': ShippingAddress,
  '/claim/shipping/edit': EditShippingAddress,
  '/claim/review': Review,
  '/claim/success': Success,
  '/claim/details': Details,
  '/claims': Claims,
  '/claims/claim': Claim,
}
const currentPath = ref(window.location.hash)
window.addEventListener('hashchange', () => {
  currentPath.value = window.location.hash
})
const currentView = computed(() => routes[currentPath.value?.slice(1) || '/'] || location.replace('/'))
//endregion
</script>

<template>
  <div class="antialiased font-avenir text-tc-black">
    <component :is="currentView"></component>
  </div>
</template>

<style scoped>

</style>
